import React, { ChangeEvent } from 'react';
import Button from './Button';
import LocalFileStorage from '../LocalFileStorage';
import { readFile } from '../utils';

type Props = {
	localFileStorage: LocalFileStorage;
	addImage: (key: IDBValidKey) => void;
};
type State = {};

class AddImageButton extends React.Component<Props, State> {
	readonly inputRef: React.RefObject<HTMLInputElement>;

	constructor(props: Props) {
		super(props);

		this.state = {};

		this.inputRef = React.createRef<HTMLInputElement>();
	}

	onClick = () => {
		const input = this.inputRef.current;
		if (!input) return;
		input.click();
	};

	onInput = async (e: ChangeEvent) => {
		const { files } = e.target as HTMLInputElement;
		if (!files) return;

		const { localFileStorage, addImage } = this.props;

		const file = files[0];
		const blob = await readFile(file);
		const localFile = await localFileStorage.addImage(blob);
		addImage(localFile.key);
	};

	render() {
		return (
			<>
				<input
					ref={this.inputRef}
					type="file"
					accept="image/*"
					multiple={false}
					onChange={this.onInput}
					style={{
						display: 'none',
					}}
				/>
				<Button
					small
					label="+ Image"
					onClick={this.onClick}
				/>
			</>
		);
	}
}

export default AddImageButton;
